import React, {Fragment, useEffect, useState, useRef} from 'react';
import {useDispatch, useSelector} from "react-redux";
import { isPointWithinRadius } from 'geolib';
import {
  handleDishOrderCountAction,
  handleAddDishToOrderAction,
  makeOrderAction,
  handleSelectDishVariationAction,
  removeOrderDishesAction,
  changeOrderCheckoutAction,
  approveOrderAction,
  makeBulkOrderAction,
  removeCategoryDishesAction
} from "../../../../store/actions/OrdersActions";
import {Collapse, Button, Modal} from "react-bootstrap";
import {Link} from "react-router-dom";
import {handleError} from "../../../../services/AlertService";
import {ReactComponent as GooglePay} from "../../../../images/GooglePay.svg";
import {ReactComponent as ApplePay} from "../../../../images/ApplePay.svg";
import {ReactComponent as Trash} from "../../../../icons/trash.svg";
import Privat from "../../../../images/privat24.svg";
import QRcodeReader from "../../../common/QRcodeReader";
import ReactGA from "react-ga4";
import {ReactComponent as PlasticCard} from "../../../../images/plastic-card.svg";
import {ReactComponent as NFC} from "../../../../images/nfc.svg";
import { useTranslation } from 'react-i18next';
import {getPackingPrice, translateRecord, dishes, isFutureTime, orderSummary, isTerminal} from "../../../common/utils";
import {ReactComponent as MonoWhite} from "../../../../images/monopay_dark.svg";
import {ReactComponent as MonoPurple} from "../../../../images/monopay_light.svg";
import WhitePlate from "../../../../icons/white-plate.svg";
import Plate from "../../../../icons/plate.svg";
import WhiteToGo from "../../../../icons/white-to-go.svg";
import ToGo from "../../../../icons/to-go.svg";
import WhiteDelivery from "../../../../icons/delivery-white.svg";
import Delivery from "../../../../icons/delivery.svg";
import {MuiPickersUtilsProvider, TimePicker} from "@material-ui/pickers";
import {uk} from "date-fns/locale";
import DateFnsUtils from "@date-io/date-fns";
import {ReactComponent as Minus} from "../../../../icons/minus.svg";
import {ReactComponent as Plus} from "../../../../icons/plus.svg";
import GetLocation from "../../../common/GetLocation";
import PhoneInput from "react-phone-input-2";
import {ReactComponent as DropDown} from "../../../../icons/dropdown-down.svg";
import {ReactComponent as Money} from "../../../../icons/cash.svg";
import Loading from "../../../common/Loading";
import {dishSearch} from "../../../../services/RestaurantService";
import Category from "./Category";
import Dish from "./Dish";
import {stopListSearch} from "../../../../services/admin/SettingsService";
import {changeSortedDishesAction, getSortedDishesAction} from "../../../../store/actions/RestaurantActions";
import EmojiView from "./EmojiView";
import PlatesView from "./PlatesView";

const Menu = (props) => {
  const dispatch = useDispatch();
  const store = useSelector(store => store.restaurants);
  const storeOrders = useSelector(store => store.orders);
  const storeAuth = useSelector(store => store.auth);
  const [activeAccordionActiveHeader, setActiveAccordionActiveHeader] = useState('');
  const [disabledMakeOrder, setDisabledMakeOrder] = useState(false);
  const [makeOrderOnTableModal, setMakeOrderOnTableModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [state, setState] = useState({
    showInitialModal: false,
    qrProveFunction: undefined,
    description: '',
    selectedSubcategory: false,
    when_ready: true,
    showGetLocation: !!JSON.parse(localStorage.getItem('locationGranted')),
    detectedLocation: {lat: null, lng: null},
    candidates: {}
  });
  const slug = !!props.selectedExtraMenu && !!props.selectedExtraMenu.slug ? props.selectedExtraMenu.slug : props.restaurant.slug;
  const restaurant = !!props.selectedExtraMenu && !!props.selectedExtraMenu.slug ? store.restaurants[slug] : props.restaurant;
  const menu = restaurant.menu;
  const refs = useRef({});
  const stickyRefs = useRef({});
  const hiddenCategoryRefs = useRef({});
  const { t } = useTranslation();

  useEffect(() => {
    if (window.location.host === 'gotovo.app' && isDefaultUser()) {
      ReactGA.initialize("G-KHNZTGMRJE");
      ReactGA.send({hitType: "pageview", page: window.location.pathname});
    }
    if (!!props.table) {
      const orderType = props.table.room.only_packable ? 'to_go' : 'on_table';
      dispatch(changeOrderCheckoutAction('selectedOrderType', orderType));
    }
  }, []);

  useEffect(() => {
    if (!!state.qrProveFunction && !!state.detectedLocation.lat && isPointWithinRadius(
        { latitude: ''+state.detectedLocation.lat, longitude: ''+state.detectedLocation.lng },
        { latitude: store.restaurants[props.restaurant.slug].latitude,
          longitude: store.restaurants[props.restaurant.slug].longitude }, 100)) {
      state.qrProveFunction()
    }
  }, [state.detectedLocation]);

  useEffect(() => {
    if (!!searchTerm) {
      const delayDebounceFn = setTimeout(() => {
        if (searchTerm.length > 1) {
          (!props.fromDashboard ? dishSearch(restaurant.id, searchTerm) : stopListSearch(searchTerm)).then((resp) => {
            setState({...state, candidates: resp.data.candidates})
          })
        }
      }, 1000);

      return () => clearTimeout(delayDebounceFn)
    }
  }, [searchTerm]);

  useEffect(() => {
    if (!!props.selectedCategoryDish && props.selectedCategoryDish[restaurant.id] &&
          Object.keys(restaurant.menu).includes(` ${props.selectedCategoryDish[restaurant.id].id}`)) {
      toggleAccordion(props.selectedCategoryDish[restaurant.id])
    } else {
      toggleAccordion(selectedCategory());
    }
  }, [restaurant.slug, store.selectedCategory]);

  function handleLocationChange({ latitude, longitude }) {
    setState({...state, detectedLocation: {lat: latitude, lng: longitude}});
  }

  const selectedCategory = () => {
    return !!store.selectedCategory && !!restaurant.menu &&
      !!store.categories[store.selectedCategory].restaurants[restaurant.id] &&
      !!store.categories[store.selectedCategory].restaurants[restaurant.id].menu &&
      restaurantMenu(store.categories[store.selectedCategory].restaurants[restaurant.id].menu)[0];
  };

  function toggleAccordion(category) {
    if (!!category) {
      if (!!props.company) {
        setActiveAccordionActiveHeader(category.id);
        if (!!refs.current[category.id]) {
          window.scrollTo({
            top: refs.current[category.id].offsetTop - 230,
            left: 0,
            behavior: "smooth",
          });
        }
      } else {
        getCategoryDishes(category);
      }
    }
  }

  function isDefaultUser() {
    const userDetails = JSON.parse(localStorage.getItem('userDetails'));
    return !userDetails || userDetails.userData.role === 'default'
  }

  function calculateCount(dish) {
    if (dish.weight_flag) {
      return parseFloat(dish.weight);
    } else {
      return 1;
    }
  }

  function calculateQuantity(dish) {
    if (dish.weight_flag) {
      return !!dish.min_order ? Math.max(...[parseFloat(dish.weight), parseFloat(dish.min_order)]) : parseFloat(dish.weight);
    } else {
      return parseFloat(dish.min_order) || 1;
    }
  }

  function handleDishOrderCount(dish, value, s) {
    const rSlug = s || slug;
    const newQuantity = storeOrders.orderDishes[rSlug].dishes[dish.uid].quantity + value;
    let reducerDishes = {};
    if (newQuantity > (!!dish.min_order ? parseFloat(dish.min_order) - (dish.weight_flag ? parseFloat(dish.weight) : 1) : 0)) {
      reducerDishes = {
        ...storeOrders.orderDishes,
        [rSlug]: {
          ...storeOrders.orderDishes[rSlug],
          dishes: {
            ...storeOrders.orderDishes[rSlug].dishes,
            [dish.uid]: {
              ...storeOrders.orderDishes[rSlug].dishes[dish.uid],
              quantity: parseFloat(newQuantity)
            }
          }
        }
      };
      dispatch(handleDishOrderCountAction(reducerDishes, storeOrders.orderDishes[rSlug].restaurant));
    } else {
      let dishes = storeOrders.orderDishes[rSlug].dishes;
      delete dishes[dish.uid];
      if (Object.keys(dishes).length > 0) {
        reducerDishes = {
          ...storeOrders.orderDishes,
          [rSlug]: {
            ...storeOrders.orderDishes[rSlug],
            dishes: dishes
          }
        };
        dispatch(handleDishOrderCountAction(reducerDishes, storeOrders.orderDishes[rSlug].restaurant));
      } else {
        if (splitedOrdersCount() < 2) {
          setMakeOrderOnTableModal(false);
        }
        dispatch(removeOrderDishesAction(rSlug))
      }
    }
  }

  function handleAddDishToOrder(dish, category) {
    let reducerDishes = {};
    let isSplited = false;
    if (!!store.restaurants[props.restaurant.slug].extra_menus) {
      isSplited = true;
    }
    if (!!storeOrders.orderDishes[slug]) {
      reducerDishes = {
        restaurant: Object.assign(restaurant, {isSplited: isSplited}),
        dishes: {
          ...storeOrders.orderDishes[slug].dishes,
          [dish.uid]: Object.assign(Object.assign(dish,
            {quantity: calculateQuantity(dish), categoryPrice: category.price, category_name: category.content,
              category_name_en: category.content_en, categoryType: props.activeCategoryType,
              categoryPackage: category.has_package}))
        },
        company: props.company
      }
    } else {
      reducerDishes = {
        restaurant: Object.assign(restaurant, {isSplited: isSplited}),
        dishes: {
          [dish.uid]: Object.assign(Object.assign(dish,
            {quantity: calculateQuantity(dish), categoryPrice: category.price, category_name: category.content,
              category_name_en: category.content_en, categoryType: props.activeCategoryType,
              categoryPackage: category.has_package}))
        },
        company: props.company
      }
    }
    dispatch(handleAddDishToOrderAction(restaurant, reducerDishes));
    if (!!props.passedFunction && props.hasSplitedTableOrder()) {
      dispatch(changeOrderCheckoutAction('selectedOrderType', 'on_table'));
    }
  }

  function selectDishVariation(dish, dishVariation, category) {
    const isSplited = !!store.restaurants[props.restaurant.slug].extra_menus;
    const quantity = !dish.weight_flag ? parseFloat(dish.min_order) || 1 : 1;
    const updatedDish = {...dish, selectedVariation: dishVariation, quantity: quantity, uid: dishVariation.uid,
      price: dishVariation.price, categoryPrice: category.price, category_name: category.content,
      categoryPackage: category.has_package, category_name_en: category.content_en, categoryType: props.activeCategoryType};
    const updatedRestaurant = {...restaurant, isSplited};
    const updatedDishes = {...storeOrders.orderDishes[slug]?.dishes, [dishVariation.uid]: updatedDish};
    const reducerDishes = {
      ...storeOrders.orderDishes,
      [slug]: {
        restaurant: updatedRestaurant,
        dishes: updatedDishes,
        company: props.company
      }
    };
    dispatch(handleSelectDishVariationAction(restaurant, reducerDishes));
    if (!!props.passedFunction && props.hasSplitedTableOrder()) {
      dispatch(changeOrderCheckoutAction('selectedOrderType', 'on_table'));
    }
  }

  function countDishVariation(dish, dishVariation, value, s) {
    const rSlug = s || slug;
    const quantity = parseFloat(storeOrders.orderDishes[rSlug].dishes[dishVariation.uid].quantity);
    const newQuantity = quantity + value;
    let reducerDishes = {};
    if (newQuantity > (!!dish.min_order && !dish.weight_flag ? parseFloat(dish.min_order) - 1 : 0)) {
      reducerDishes = {
        ...storeOrders.orderDishes,
        [rSlug]: {
          ...storeOrders.orderDishes[rSlug],
          dishes: {
            ...storeOrders.orderDishes[rSlug].dishes,
            [dishVariation.uid]: {
              ...storeOrders.orderDishes[rSlug].dishes[dishVariation.uid],
              quantity: newQuantity
            }
          }
        }
      };
      dispatch(handleSelectDishVariationAction(storeOrders.orderDishes[rSlug].restaurant, reducerDishes))
    } else {
      let dishes = storeOrders.orderDishes[rSlug].dishes;
      delete dishes[dishVariation.uid];
      if (Object.keys(dishes).length > 0) {
        reducerDishes = {
          ...storeOrders.orderDishes,
          [rSlug]: {
            ...storeOrders.orderDishes[rSlug],
            dishes: dishes
          }
        };
        dispatch(handleDishOrderCountAction(reducerDishes, storeOrders.orderDishes[rSlug].restaurant));
      } else {
        if (splitedOrdersCount() < 2) {
          setMakeOrderOnTableModal(false);
        }
        dispatch(removeOrderDishesAction(rSlug))
      }
    }
  }

  function selectComplexDish(dish, dishVariation, category) {
    let reducerDishes = {};
    if (!dish.available || !dishVariation.available) {return;}
    let isSplited = false;
    if (!!store.restaurants[props.restaurant.slug].extra_menus) {
      isSplited = true;
    }
    if (!!storeOrders.orderDishes[slug] && !!storeOrders.orderDishes[slug].dishes[dishVariation.uid]) {
      let dishes = storeOrders.orderDishes[slug].dishes;
      delete dishes[dishVariation.uid];
      reducerDishes = {
        ...storeOrders.orderDishes,
        [slug]: {
          ...storeOrders.orderDishes[slug],
          restaurant: Object.assign(restaurant, {isSplited: isSplited}),
          dishes: dishes
        }
      }
    } else {
      const updatedDish = {...dish, selectedVariation: dishVariation, uid: dishVariation.uid,
        categoryPrice: category.price, category_name: category.content, categoryPackage: category.has_package,
        category_name_en: category.content_en, categoryType: props.activeCategoryType};
      if (!!storeOrders.orderDishes[slug]) {
        const sameDish = Object.values(storeOrders.orderDishes[slug].dishes).filter((d) => d.id === dish.id)[0];
        if (!!sameDish) {
          let dishes = storeOrders.orderDishes[slug].dishes;
          delete dishes[sameDish.selectedVariation.uid];
          reducerDishes = {
            ...storeOrders.orderDishes,
            [slug]: {
              ...storeOrders.orderDishes[slug],
              restaurant: Object.assign(restaurant, {isSplited: isSplited}),
              dishes: {
                ...storeOrders.orderDishes[slug].dishes,
                [dishVariation.uid]: updatedDish
              }
            }
          }
        } else {
          reducerDishes = {
            ...storeOrders.orderDishes,
            [slug]: {
              ...storeOrders.orderDishes[slug],
              restaurant: Object.assign(restaurant, {isSplited: isSplited}),
              dishes: {
                ...storeOrders.orderDishes[slug].dishes,
                [dishVariation.uid]: updatedDish
              }
            }
          }
        }
      } else {
        reducerDishes = {
          ...storeOrders.orderDishes,
          [slug]: {
            ...storeOrders.orderDishes[slug],
            restaurant: Object.assign(restaurant, {isSplited: isSplited}),
            dishes: {
              [dishVariation.uid]: updatedDish
            }
          }
        }
      }
    }
    dispatch(handleSelectDishVariationAction(restaurant, reducerDishes))
  }

  function makeOrderOnTable(paymentType, afterPayMethod) {
    setDisabledMakeOrder(true);
    let params = {selectedOrderType: storeOrders.orderCheckout.selectedOrderType, selectedPaymentType: paymentType,
      selectedReadyType: storeOrders.orderCheckout.selectedReadyType, phone: storeOrders.orderCheckout.phone,
      time: storeOrders.orderCheckout.selectedReadyType === 'when_ready' ? new Date() : storeOrders.orderCheckout.time,
      table_id: props.table.id, description: state.description, after_pay_method: afterPayMethod};
    if (storeOrders.orderCheckout.selectedOrderType !== 'on_table') {
      Object.assign(params, {qr_id: props.table.id})
    }
    if (storeOrders.orderCheckout.selectedOrderType !== 'to_go') {
      Object.assign(params, {persons: storeOrders.orderCheckout.persons})
    }
    if (!storeAuth.auth.idToken && !!storeAuth.auth.userData.theme) {
      params['theme'] = storeAuth.auth.userData.theme
    }
    params['from_terminal'] = isTerminal;
    if (props.restaurant.allow_extra_menus && !!props.restaurant.extra_menus) {
      makeBulkOrderOnTable(params)
    } else {
      dispatch(makeOrderAction(props.restaurant, Object.values(storeOrders.orderDishes[props.restaurant.slug].dishes),
          params, false, props.history)).catch((error) => {
        handleError(error.response.data.errors, error.response)
      }).then(() => setDisabledMakeOrder(false))
    }
  }

  function makeBulkOrderOnTable(params) {
    let orders = {};
    if (!!storeOrders.orderDishes[props.restaurant.slug] &&
        Object.keys(storeOrders.orderDishes[props.restaurant.slug].dishes).length > 0) {
      orders[props.restaurant.id] = Object.values(storeOrders.orderDishes[props.restaurant.slug].dishes);
    }
    props.restaurant.extra_menus.map((m) => {
      if (!!storeOrders.orderDishes[m.slug] && Object.keys(storeOrders.orderDishes[m.slug].dishes).length > 0) {
        orders[m.id] = Object.values(storeOrders.orderDishes[m.slug].dishes)

      }
    });
    params['parent_restaurant_id'] = props.restaurant.id;
    dispatch(makeBulkOrderAction(orders, params, props.history)).catch((error) => {
      handleError(error.response.data.errors, error.response)}).then(() => setDisabledMakeOrder(false))
  }

  function selectedDishesCount(category) {
    if (storeOrders.orderDishes[slug] && Object.keys(storeOrders.orderDishes[slug].dishes).length > 0) {
      const selectedCategories = Object.values(storeOrders.orderDishes[slug].dishes).map((d) => d.category_dish_id);
      if (selectedCategories.includes(parseInt(category.id))) {
        return selectedCategories.filter((c) => c === parseInt(category.id)).length
      } else {
        return 0
      }
    } else {
      return 0
    }
  }

  function getCategoryDishes(category) {
    if (!!category) {
      setActiveAccordionActiveHeader(activeAccordionActiveHeader === category.id ? '' : category.id);
      setState({...state, selectedSubcategory: false});
    }
  }

  function dishParameter(dish, param) {
    if (param === 'name') {
      return translateRecord(dish, param);
    } else if (param === 'weight') {
      return !!dish.weight ? `${dish.weight}${t(`measures.${dish['measure']}`)}` : '';
    } else {
      return dish[param];
    }
  }

  function tableOrderSummary() {
    let summary = tableOrderWithoutCommission();
    if (!!props.restaurant.order_types.on_table.commission && props.restaurant.table.room.service_commission &&
          storeOrders.orderCheckout.selectedOrderType === 'on_table') {
      summary += serviceCommission(summary)
    }
    return summary;
  }

  function tableOrderWithoutCommission() {
    let summary = orderSummary(props.restaurant.slug);
    if (!!props.tableId && props.restaurant.allow_extra_menus && !!props.restaurant.extra_menus) {
      props.restaurant.extra_menus.map((m) => summary += orderSummary(m.slug))
    }
    return summary;
  }

  function serviceCommission(sum) {
    return sum * parseFloat(restaurant.order_types.on_table.commission)/100.0;
  }

  function toggleQRprove(func) {
    if (process.env.REACT_APP_ENV === 'development' || storeOrders.approveOrder ||
        (!!storeAuth.auth.userData && !!storeAuth.auth.userData.phone &&
        storeAuth.auth.userData.phone.length > 11 && !storeAuth.auth.userData.guest) ||
        (!!state.detectedLocation.lat && isPointWithinRadius(
          { latitude: ''+state.detectedLocation.lat, longitude: ''+state.detectedLocation.lng },

          { latitude: restaurant.latitude,
            longitude: restaurant.longitude }, 100))) {
      func()
    } else {
      setState({...state, showInitialModal: true, qrProveFunction: func})
    }
  }

  function clearOrders() {
    dispatch(removeOrderDishesAction(props.restaurant.slug));
    if (!!restaurant.extra_menus) {
      restaurant.extra_menus.map((m) =>
        dispatch(removeOrderDishesAction(m.slug))
      )
    }
  }

  function orderTypeIcon() {
    if (storeOrders.orderCheckout.selectedOrderType === 'to_visit' || storeOrders.orderCheckout.selectedOrderType === 'on_table') {
      return !!storeAuth.auth.userData && storeAuth.auth.userData.theme === 'dark' ? WhitePlate : Plate;
    } else if (storeOrders.orderCheckout.selectedOrderType === 'to_go') {
      return !!storeAuth.auth.userData && storeAuth.auth.userData.theme === 'dark' ? WhiteToGo : ToGo;
    } else {
      return !!storeAuth.auth.userData && storeAuth.auth.userData.theme === 'dark' ? WhiteDelivery : Delivery;
    }
  }

  function handleTimeChange(value) {
    const selectedTime = new Date();
    selectedTime.setHours(value.getHours());
    selectedTime.setMinutes(value.getMinutes());
    if (new Date() > selectedTime) {
      selectedTime.setDate(new Date().getDate() + 1)
    }
    dispatch(changeOrderCheckoutAction('time', selectedTime));
  }

  function grantGeoLocation() {
    localStorage.setItem('locationGranted', 'true');
    setState({...state, showGetLocation: true});
  }

  function approveOrder() {
    dispatch(approveOrderAction());
    setMakeOrderOnTableModal(true);
    setState({...state, showInitialModal: false})
  }

  function packingPrice() {
    let result = getPackingPrice(props.restaurant.slug);
    !!restaurant.extra_menus && restaurant.extra_menus.map((m) =>
      result += getPackingPrice(m.slug)
    );
    return result;
  }

  function splitedOrdersCount() {
    let result = 0;
    if (!!props.restaurant.extra_menus) {
      let slugs = props.restaurant.extra_menus.map((r) => r.slug);
      slugs.push(props.restaurant.slug);
      Object.keys(storeOrders.orderDishes).map((slug) => {
        if (slugs.includes(slug)) {
          result += 1;
        }
      });
    }
    return result;
  }

  function restaurantMenu(categories) {
    let result = [];
    const isOrderTypeToGoOrDelivery = ['to_go', 'delivery'].includes(storeOrders.orderCheckout.selectedOrderType);
    Object.values(categories).filter((c) => c.available || props.fromDashboard)
        .sort((a,b) => a.position - b.position).forEach((category) => {
      const shouldBeIncluded = () => {
        if (isOrderTypeToGoOrDelivery) {
          return category.packable_dishes_count > 0;
        }
        return true;
      };
      if (shouldBeIncluded()) {
        result.push(category);
      }
    });
    return result;
  }

  function variationsAvailable(dish) {
    const variations = Object.values(dish.dish_variations);
    if (variations.length > 0) {
      return dish.available && variations.filter((v) => !v.available).length !== variations.length
    } else {
      return dish.available
    }
  }

  function hasQRorders() {
    return Object.values(store.restaurants[slug].order_types.on_table).includes(true);
  }

  function selectSort(sort) {
    dispatch(changeSortedDishesAction(restaurant, sort));
    if (!restaurant[sort]) {
      dispatch(getSortedDishesAction(restaurant, sort))
    }
  }

  function sortedDishes() {
    return restaurant[restaurant.sort]
      .filter((d) => storeOrders.orderCheckout.selectedOrderType === 'to_go' ||
      storeOrders.orderCheckout.selectedOrderType === 'delivery' ? d.packable : true)
  }

  //console.log('menu props', props);
  //console.log('restaurant', restaurant);
  //console.log('menu store', store);
  // console.log('menu state', state);
  // console.log('storeOrders', storeOrders);
  //console.log('storeAuth', storeAuth);
  //console.log('localStorage', localStorage);

  return (
    <div className='menu-content' style={!!props.company ? {marginBottom: 0} : {}}>
      { !!props.company && !!menu && restaurantMenu(menu).length === 1 ?
        <div ref={(el) => {refs.current[restaurantMenu(menu)[0].id] = el}}>
          <Category category={restaurantMenu(menu)[0]} selectedSubcategory={state.selectedSubcategory} refs={refs}
                    noPhoto={props.noPhoto} setState={setState} state={state}
                    handleDishOrderCount={handleDishOrderCount}
                    handleAddDishToOrder={handleAddDishToOrder}
                    selectDishVariation={selectDishVariation}
                    selectComplexDish={selectComplexDish}
                    dishParameter={dishParameter} singleCategory={true}
                    calculateCount={calculateCount}
                    table={props.table} company={props.company}
                    acceptOutsideOrders={props.acceptOutsideOrders}
                    countDishVariation={countDishVariation}
                    restaurant={restaurant}/>
        </div>
      :
        <>
          { !props.company &&
            <>
              { !props.fromDashboard && !!restaurant.available_collections && restaurant.available_collections.length > 0 &&
                !props.table?.is_terminal &&
                <>
                  <div className="sorting pb-3">
                    { restaurant.available_collections.map((c, i) =>
                      <Button onClick={() => selectSort(c)} key={i}
                        className={`btn-xxs btn-rounded mr-1 my-1 ${restaurant.sort === c ? 'btn-primary' : (!!storeAuth.auth.userData && storeAuth.auth.userData.theme === 'dark' ? 'btn-dark' : 'btn-light')}`}
                      >
                        <b>{t(`components.menu.sortedDishes.${c}`)}</b>
                      </Button>)}
                  </div>
                  <div className='d-flex align-items-baseline justify-content-start' style={{overflowX: 'auto'}}>
                    { !!restaurant[restaurant.sort] ?
                      <>
                        { sortedDishes().length > 0 ?
                          <>
                            {sortedDishes().map((d, index) =>
                              <div style={{maxWidth: 350, minWidth: 350}} className='mr-2' key={index}>
                                <Dish dish={d} handleDishOrderCount={handleDishOrderCount}
                                      handleAddDishToOrder={handleAddDishToOrder}
                                      selectDishVariation={selectDishVariation}
                                      selectComplexDish={selectComplexDish}
                                      dishParameter={dishParameter} index={index}
                                      variationsAvailable={variationsAvailable}
                                      calculateCount={calculateCount} noPhoto={props.noPhoto}
                                      storeAuth={storeAuth} table={props.table}
                                      acceptOutsideOrders={props.acceptOutsideOrders}
                                      countDishVariation={countDishVariation}
                                      category={menu[` ${d.category_dish_id}`]}
                                      restaurant={restaurant} fromDashboard={props.fromDashboard}/>
                              </div>)}
                          </>
                        :
                          <h6 className='text-black text-center mb-3'>Немає страв для відображення</h6>}
                      </>
                    :
                      <Loading/>}
                  </div>
                </>}
              <div className='input-group w-100 mb-3'>
                <input className='form-control' type='text' value={searchTerm}
                       placeholder={t('components.menu.search')} onChange={(e) => setSearchTerm(e.target.value)}/>
                { searchTerm.length > 0 &&
                  <div className='input-group-append' style={{cursor: 'pointer'}} onClick={() => setSearchTerm('')}>
                    <span className='input-group-text'>&times;</span>
                  </div>}
              </div>
              { searchTerm.length > 0 &&
                <div className='row'>
                  { Object.values(state.candidates).map((d, index) =>
                    <Fragment key={index}>
                      { !!menu[` ${d.category_dish_id}`] &&
                      <div className='col-lg-4 col-md-6'>
                        <Dish dish={d} handleDishOrderCount={handleDishOrderCount}
                                handleAddDishToOrder={handleAddDishToOrder}
                                selectDishVariation={selectDishVariation}
                                selectComplexDish={selectComplexDish}
                                dishParameter={dishParameter} index={index}
                                variationsAvailable={variationsAvailable}
                                calculateCount={calculateCount} noPhoto={props.noPhoto}
                                storeAuth={storeAuth} table={props.table}
                                acceptOutsideOrders={props.acceptOutsideOrders}
                                countDishVariation={countDishVariation}
                                category={menu[` ${d.category_dish_id}`]}
                                restaurant={restaurant} fromDashboard={props.fromDashboard}/>
                      </div>}
                    </Fragment>)}
                </div>}
            </>}
          { !!menu &&
            <>
              { isTerminal ?
                <PlatesView menu={restaurantMenu(menu)} activeCategory={activeAccordionActiveHeader}
                         company={props.company} getCategoryDishes={getCategoryDishes} slug={slug}
                         handleDishOrderCount={handleDishOrderCount} handleAddDishToOrder={handleAddDishToOrder}
                         selectDishVariation={selectDishVariation} selectComplexDish={selectComplexDish}
                         dishParameter={dishParameter} calculateCount={calculateCount} setState={setState} state={state}
                         countDishVariation={countDishVariation} restaurant={restaurant}
                         selectedDishesCount={selectedDishesCount} table={props.table}
                         acceptOutsideOrders={props.acceptOutsideOrders} fromDashboard={props.fromDashboard}/>
              :
                <EmojiView menu={restaurantMenu(menu)} activeCategory={activeAccordionActiveHeader}
                         company={props.company} getCategoryDishes={getCategoryDishes} slug={slug}
                         handleDishOrderCount={handleDishOrderCount} handleAddDishToOrder={handleAddDishToOrder}
                         selectDishVariation={selectDishVariation} selectComplexDish={selectComplexDish}
                         dishParameter={dishParameter} calculateCount={calculateCount} setState={setState} state={state}
                         countDishVariation={countDishVariation} restaurant={restaurant}
                         selectedDishesCount={selectedDishesCount} table={props.table}
                         acceptOutsideOrders={props.acceptOutsideOrders} fromDashboard={props.fromDashboard}/>}
              { !props.company && ((Object.keys(storeOrders.orderDishes).length > 0 && storeOrders.orderDishes[slug] &&
                  Object.keys(storeOrders.orderDishes[slug].dishes).length > 0) ||
                    (!!props.restaurant.table && tableOrderSummary() > 0)) &&
                <div className='d-flex align-items-center justify-content-between'>
                  { !props.fromDashboard &&
                    <>
                      <Button className={`btn-danger cancel-order ${isTerminal && 'terminal-order'}`} onClick={() => clearOrders()}>
                        <Trash style={{height: 27, width: 27}} fill='white'/>
                      </Button>
                      { !!props.restaurant.table ?
                        <>
                          { hasQRorders() ?
                            <Button onClick={approveOrder} className={`btn btn-primary make-order ${isTerminal && 'terminal-order'}`}>
                              {t('components.menu.toOrder')} {tableOrderSummary().toFixed(2)}<small>₴</small>
                            </Button>
                          :
                            <Button onClick={() => toggleQRprove(approveOrder)} className='btn btn-primary make-order'>
                              {t('ordering')} {tableOrderSummary().toFixed(2)}<small>₴</small>
                            </Button>}
                        </>
                      :
                        <Link to={{pathname: `/checkout/${props.restaurant.slug}`,
                          state: { isOperator: props.isOperator, selectedOrderType: storeOrders.orderCheckout.selectedOrderType }}}
                              className='btn btn-primary make-order'
                        >
                          {t('components.menu.toOrder')} {orderSummary(props.restaurant.slug).toFixed(2)}<small>₴</small>
                        </Link>}
                    </>}
                </div>}
            </>}
        </>}

      {/*Table order modal*/}

      { !!props.restaurant.table && Object.keys(storeOrders.orderDishes).length > 0 && makeOrderOnTableModal &&
        <Modal className='fade' show={makeOrderOnTableModal} size="lg">
          <Modal.Header>
            <Modal.Title className='text-black'>
              {hasQRorders() ? t('components.menu.orderConfirm') : t('cart')}
            </Modal.Title>
            <Button variant="" className="close" onClick={() => setMakeOrderOnTableModal(false)}>
              <span>&times;</span>
            </Button>
          </Modal.Header>
          <Modal.Body>
            { hasQRorders() &&
              <>
                { store.restaurants[props.restaurant.slug].table.room.ask_after_pay_method &&
                  store.restaurants[props.restaurant.slug].table.room.allow_other_orders &&
                  !props.table?.is_terminal &&
                  <>
                    <h6>{t('components.menu.whereToEat')}</h6>
                    <div className='d-flex align-items-center justify-content-around order-types mb-3'>
                      { ['on_table', 'to_visit', 'to_go'].map((order_type, i) =>
                        <Fragment key={i}>
                          <div onClick={() => props.handeTableOrderTypeChange(order_type)}
                               className={`${storeOrders.orderCheckout.selectedOrderType === order_type && 'btn-primary w-100'} order-type`}
                          >
                            <h6 className='mb-0' style={{color: storeOrders.orderCheckout.selectedOrderType === order_type && 'white'}}>
                              {t(`after_pay_methods.${order_type}.name`)}
                            </h6>
                          </div>
                        </Fragment>)}
                    </div>
                    <div className='text-center text-black mb-3'>
                      <img src={orderTypeIcon()} className='mr-2'/>
                      {t(`after_pay_methods.${storeOrders.orderCheckout.selectedOrderType}.description`)}
                    </div>
                    { storeOrders.orderCheckout.selectedOrderType !== 'to_go' &&
                      <div className='d-flex align-items-center justify-content-between mb-4'>
                        <h5 className="text-black mb-0" style={{minWidth: '130px'}}>{t('components.menu.personsCount')}</h5>
                        <div className='d-flex align-items-center'>
                          <Button className='btn-light py-2 px-3'
                                  onClick={() => storeOrders.orderCheckout.persons > 1 &&
                                    dispatch(changeOrderCheckoutAction('persons', storeOrders.orderCheckout.persons-1))}
                          >
                            <Minus fill='black'/>
                          </Button>
                          <input
                            style={{width: '67px', height: "36px"}}
                            type='number'
                            min={1}
                            className='form-control ml-1 mr-1 fs-20 text-center font-w700'
                            placeholder={t('components.menu.personsCount')}
                            value={storeOrders.orderCheckout.persons}
                            onChange={(e) => dispatch(changeOrderCheckoutAction('persons', e.target.value))}
                          />
                          <Button className='btn-success py-2 px-3'
                                  onClick={() => dispatch(changeOrderCheckoutAction('persons',
                                    parseInt(storeOrders.orderCheckout.persons)+1))}
                          >
                            <Plus fill='white'/>
                          </Button>
                        </div>
                      </div>}
                  </>}
                { !!storeOrders.orderDishes[props.restaurant.slug] &&
                  Object.values(storeOrders.orderDishes[props.restaurant.slug].dishes).filter((d) => d.weight_flag).length > 0 &&
                  <p className='text-center' style={{color: '#F45045'}}>
                    {t('components.menu.weightDishWarning')}
                  </p>}
                <h4>{t('components.checkout.specialNeeds')}</h4>
                <textarea rows={4} value={state.description} className='form-control mb-4'
                          placeholder={t('components.checkout.someOtherInfo')}
                          onChange={(e) => setState({...state, description: e.target.value})}/>
                { !props.table?.is_terminal &&
                  <>
                    <div className='mb-4'>
                      <h4>{t('components.checkout.whenToCook')}</h4>
                      <div className='d-flex' style={{textAlign: 'center', justifyContent: 'space-around'}}>
                        <Button className={`btn fs-16 mr-1 ${storeOrders.orderCheckout.selectedReadyType === 'when_ready' ? 'btn-primary' : 'btn-secondary'}`}
                                onClick={() => dispatch(changeOrderCheckoutAction('selectedReadyType', 'when_ready'))}
                        >
                          {t('components.checkout.asPossible')}
                        </Button>
                        <Button className={`btn fs-16 ${storeOrders.orderCheckout.selectedReadyType === 'time' ? 'btn-primary' : 'btn-secondary'}`}
                                onClick={() => dispatch(changeOrderCheckoutAction('selectedReadyType', 'time'))}
                        >
                          {t('components.checkout.setTime')}
                        </Button>
                      </div>
                      { storeOrders.orderCheckout.selectedReadyType === 'time' &&
                        <div className='text-center'>
                          <span style={{textAlign: 'justify', display: "inline-block"}} className='red-notice mt-3'>
                            {t('components.checkout.changeTimeWarning')}
                          </span>
                          <MuiPickersUtilsProvider locale={uk} utils={DateFnsUtils}>
                            <TimePicker
                              autoOk
                              ampm={false}
                              label=""
                              value={storeOrders.orderCheckout.time}
                              className='mt-4 order-time'
                              onChange={(value) => handleTimeChange(value)}
                            />
                          </MuiPickersUtilsProvider>
                          <h6 className='text-black'>
                            {isFutureTime(storeOrders.orderCheckout.time) ? t('today') : t('tomorrow')}
                          </h6>
                        </div>}
                    </div>
                    <h4>{t('components.checkout.selectPayMethod')}</h4>
                    { restaurant.order_types.on_table.pre_pay &&
                      <div className='order-dish d-flex align-items-center justify-content-between'
                              onClick={() => setState({...state, payment_method: 'pre_pay', after_pay_method: 'no_method'})}
                           style={{background: state.payment_method === 'pre_pay' &&
                               'linear-gradient(153.09deg, #FB4A35 -29.54%, #FFA149 50%)',
                             borderRadius: '10px', cursor: 'pointer'}}
                      >
                        <h6 className='text-black mb-0'>{t('components.checkout.pre_pay')}</h6>
                        <span>
                          <ApplePay fill={!!storeAuth.auth.userData && storeAuth.auth.userData.theme === 'dark' ? 'white' : 'black'}
                                    style={{height: 30, width: 60}}/>
                          <GooglePay fill={!!storeAuth.auth.userData && storeAuth.auth.userData.theme === 'dark' ? 'white' : '#5f6368'}
                                     style={{height: 30, width: 60}} className='mr-1' />
                          { store.restaurants[props.restaurant.slug].payment_provider === 'monobank' ?
                            <>
                              { !!storeAuth.auth.userData && storeAuth.auth.userData.theme === 'dark' ?
                                <MonoWhite style={{height: 30, width: 80}}/>
                                :
                                <MonoPurple style={{height: 30, width: 80}}/>}
                            </>
                          :
                            <img src={Privat} style={{width: '45px'}}/>}
                        </span>
                      </div>}
                    { store.restaurants[props.restaurant.slug].order_types.on_table.after_pay &&
                        !!props.table && props.table.room.ask_after_pay_method &&
                      <div className='order-dish d-flex align-items-center justify-content-between'
                              onClick={() => setState({...state, payment_method: 'after_pay', after_pay_method: 'cash'})}
                           style={{background: state.after_pay_method === 'cash' && state.payment_method !== 'pre_pay' &&
                               'linear-gradient(153.09deg, #FB4A35 -29.54%, #FFA149 50%)',
                             borderRadius: '10px', cursor: 'pointer'}}
                      >
                        <h6 className='text-black mb-0'>{t('components.menu.byCash')}</h6>
                        <Money stroke={!!storeAuth.auth.userData && storeAuth.auth.userData.theme === 'dark' ? 'white' : '#2F2D2A'}
                               className="ml-1" width={35} height={35}/>
                      </div>}
                    { store.restaurants[props.restaurant.slug].order_types.on_table.after_pay &&
                        store.restaurants[props.restaurant.slug].terminal &&
                        !!props.table && props.table.room.ask_after_pay_method &&
                      <div className='order-dish d-flex align-items-center justify-content-between'
                              onClick={() => setState({...state, payment_method: 'after_pay', after_pay_method: 'terminal'})}
                           style={{background: state.after_pay_method === 'terminal' && state.payment_method !== 'pre_pay' &&
                               'linear-gradient(153.09deg, #FB4A35 -29.54%, #FFA149 50%)',
                             borderRadius: '10px', cursor: 'pointer'}}
                      >
                        <h6 className='text-black mb-0'>{t('components.menu.byTerminal')}</h6>
                        <span>
                          <PlasticCard fill={!!storeAuth.auth.userData && storeAuth.auth.userData.theme === 'dark' ? 'white' : '#484645'}
                                       style={{width: '50px', height: '30px'}}/>
                          <NFC fill={!!storeAuth.auth.userData && storeAuth.auth.userData.theme === 'dark' ? 'white' : '#484645'}
                               style={{width: '25px', height: '30px'}}/>
                        </span>
                      </div>}
                    { !!props.table && !props.table.room.ask_after_pay_method &&
                      (store.restaurants[props.restaurant.slug].order_types.on_table.after_pay || !!props.table.pay_check) &&
                      <div className='order-dish d-flex align-items-center justify-content-between'
                           onClick={() => setState({...state, payment_method: 'after_pay', after_pay_method: 'no_method'})}
                           style={{background: state.payment_method === 'after_pay' &&
                               'linear-gradient(153.09deg, #FB4A35 -29.54%, #FFA149 50%)',
                             borderRadius: '10px', cursor: 'pointer'}}
                      >
                        <h6 className='text-black mb-0'>{t('components.menu.laterPay')}</h6>
                        <span>
                          <PlasticCard fill={!!storeAuth.auth.userData && storeAuth.auth.userData.theme === 'dark' ? 'white' : '#484645'}
                                       style={{width: '50px', height: '30px'}}/>
                          <Money stroke={!!storeAuth.auth.userData && storeAuth.auth.userData.theme === 'dark' ? 'white' : '#2F2D2A'}
                                 className="ml-1" width={35} height={35}/>
                        </span>
                      </div>}
                  </>}
              </>}
            <h4 className='mt-4'>{t('components.menu.yourOrder')}</h4>
            <div style={{marginBottom: 60}}>
              { !!store.restaurants[props.restaurant.slug].extra_menus && !!storeOrders.orderDishes[props.restaurant.slug] &&
                Object.keys(storeOrders.orderDishes[props.restaurant.slug].dishes).length > 0 &&
                <h5>
                  <span className='mr-1'>{translateRecord(props.restaurant, 'name')}</span>
                  <small>
                    {translateRecord(store.restaurants[props.restaurant.slug], 'extra_description')}
                  </small>
                </h5>}
              { !!storeOrders.orderDishes[props.restaurant.slug] &&
                Object.values(storeOrders.orderDishes[props.restaurant.slug].dishes).map((dish,i) =>
                <div key={i} className="d-flex align-items-center justify-content-between order-dish">
                  <div className="d-flex align-items-center" style={{maxWidth: '66%'}}>
                    <Button className='order-count'
                            onClick={() => !!dish.selectedVariation ?
                              countDishVariation(dish, dish.selectedVariation, -1, props.restaurant.slug)
                            :
                              handleDishOrderCount(dish, -calculateCount(dish), props.restaurant.slug)}
                            style={{color: !!storeAuth.auth.userData && storeAuth.auth.userData.theme === 'dark' ? 'white' : '#130B01', padding: '0 7.5px'}}>
                      <strong>-</strong>
                    </Button>
                    <div className='ml-2'>
                      <h6 className="mt-0 mb-0">
                        { !!storeOrders.orderDishes[props.restaurant.slug].restaurant.menu[` ${dish.category_dish_id}`].price ?
                          translateRecord(storeOrders.orderDishes[props.restaurant.slug].restaurant.menu[` ${dish.category_dish_id}`], 'content')
                        :
                          dishParameter(dish, 'name')}
                      </h6>
                      <small className="text-muted">
                        {dishParameter(dish, 'weight')} {!!dish.selectedVariation && `${!!dishParameter(dish, 'weight') ? '-' : ''} ${translateRecord(dish.selectedVariation, 'name')}`}
                      </small>
                    </div>
                  </div>
                  { !storeOrders.orderDishes[props.restaurant.slug].restaurant.menu[` ${dish.category_dish_id}`].price &&
                    <div className="d-flex align-items-center">
                      <span className="text-muted">
                        {dishParameter(dish, 'price')}<small>₴</small>
                        {dishParameter(dish, 'quantity') > 1 ?
                          ` x ${dishParameter(dish, 'quantity')}${dish.weight_flag && !dish.selectedVariation ? t(`measures.${dish['measure']}`) : ''}`
                          : ''}
                      </span>
                      <Button className='ml-2 order-count'
                        onClick={() => !!dish.selectedVariation ?
                          countDishVariation(dish, dish.selectedVariation, 1, props.restaurant.slug)
                        :
                          handleDishOrderCount(dish, calculateCount(dish), props.restaurant.slug)}
                        style={{color: !!storeAuth.auth.userData && storeAuth.auth.userData.theme === 'dark' ? 'white' : '#130B01'}}
                      >
                        <strong>+</strong>
                      </Button>
                    </div>}
                  </div>)}
              { !!store.restaurants[props.restaurant.slug].extra_menus &&
                  store.restaurants[props.restaurant.slug].extra_menus.map((m, index) =>
                <Fragment key={index}>
                  { !!storeOrders.orderDishes[m.slug] &&
                    <>
                      { Object.keys(storeOrders.orderDishes[m.slug].dishes).length > 0 &&
                        <h5>
                          <span className='mr-1'>
                            {translateRecord(storeOrders.orderDishes[m.slug].restaurant, 'name')}
                          </span>
                          <small>
                            {translateRecord(storeOrders.orderDishes[m.slug].restaurant, 'extra_description')}
                          </small>
                        </h5>}
                      { Object.values(storeOrders.orderDishes[m.slug].dishes).map((dish, i) =>
                        <div key={i} className="d-flex align-items-center justify-content-between order-dish">
                          <div className="d-flex align-items-center" style={{maxWidth: '66%'}}>
                            <Button className='order-count'
                                    onClick={() => !!dish.selectedVariation ?
                                      countDishVariation(dish, dish.selectedVariation, -1, m.slug)
                                      :
                                      handleDishOrderCount(dish, -calculateCount(dish), m.slug)}
                                    style={{color: !!storeAuth.auth.userData && storeAuth.auth.userData.theme === 'dark' ? 'white' : '#130B01', padding: '0 7.5px'}}>
                              <strong>-</strong>
                            </Button>
                            <div className='ml-2'>
                              <h6 className="mt-0 mb-0">
                                { !!storeOrders.orderDishes[m.slug].restaurant.menu[` ${dish.category_dish_id}`].price ?
                                  translateRecord(storeOrders.orderDishes[m.slug].restaurant.menu[` ${dish.category_dish_id}`], 'content')
                                :
                                  dishParameter(dish, 'name')}
                              </h6>
                              <small className="text-muted">
                                {dishParameter(dish, 'weight')} {!!dish.selectedVariation && `${!!dishParameter(dish, 'weight') ? '-' : ''} ${translateRecord(dish.selectedVariation, 'name')}`}
                              </small>
                            </div>
                          </div>
                          { !storeOrders.orderDishes[m.slug].restaurant.menu[` ${dish.category_dish_id}`].price &&
                          <div className="d-flex align-items-center">
                                              <span className="text-muted">
                                                {dishParameter(dish, 'price')}<small>₴</small>
                                                {dishParameter(dish, 'quantity') > 1 ?
                                                  ` x ${dishParameter(dish, 'quantity')}${dish.weight_flag && !dish.selectedVariation ? t(`measures.${dish['measure']}`) : ''}`
                                                  : ''}
                                              </span>
                            <Button className='ml-2 order-count'
                                    onClick={() => !!dish.selectedVariation ?
                                      countDishVariation(dish, dish.selectedVariation, 1, m.slug)
                                      :
                                      handleDishOrderCount(dish, calculateCount(dish), m.slug)}
                                    style={{color: !!storeAuth.auth.userData && storeAuth.auth.userData.theme === 'dark' ? 'white' : '#130B01'}}
                            >
                              <strong>+</strong>
                            </Button>
                          </div>}
                        </div>)}
                    </>}
                </Fragment>)}
              {(storeOrders.orderCheckout.selectedOrderType === 'to_go') &&
                <div className="d-flex align-items-center justify-content-between order-dish">
                  <h6 className="my-0">+ {t('components.checkout.packing')}</h6>
                  <span className="text-muted">{packingPrice().toFixed(2)}<small>₴</small></span>
                </div>}
              { !!store.restaurants[props.restaurant.slug].order_types.on_table.commission &&
                  store.restaurants[props.restaurant.slug].table.room.service_commission &&
                  storeOrders.orderCheckout.selectedOrderType === 'on_table' &&
                <div className="d-flex align-items-center justify-content-between order-dish">
                  <h6 className="mt-0 mb-0">
                    + {t('components.menu.commission')} ({store.restaurants[props.restaurant.slug].order_types.on_table.commission}%)
                  </h6>
                  <span className='text-muted'>
                    {serviceCommission(tableOrderWithoutCommission()).toFixed(2)}<small>₴</small>
                  </span>
                </div>}
              <div className="d-flex align-items-center justify-content-between order-dish">
                <h6 className="mt-0 mb-0">{t('total')}:</h6>
                <span className='text-muted'><strong>{tableOrderSummary().toFixed(2)}<small>₴</small></strong></span>
              </div>
              { hasQRorders() &&
                <>
                  { (!(!!storeAuth.auth.userData && storeAuth.auth.userData.phone) ||
                    (!!storeAuth.auth.userData && !!storeAuth.auth.userData.phone && storeAuth.auth.userData.phone.length < 12)) &&
                    <>
                      <label>Телефон (Необов'язково)</label>
                      <PhoneInput className='w-100' country={'ua'} value={storeOrders.orderCheckout.phone}
                                    onChange={phone => dispatch(changeOrderCheckoutAction('phone', phone))}
                      />
                    </>}
                  { props.hasSplitedTableOrder() &&
                    <h6 className='red-notice mt-2'>Замовлення буде розділено на {splitedOrdersCount()} заклади</h6>}
                </>}
            </div>

            { hasQRorders() &&
              <Button className='btn-primary make-order make-order-checkout' style={{bottom: 5}}
                      disabled={disabledMakeOrder}
                      onClick={(!!state.after_pay_method || props.table?.is_terminal) ?
                        () => makeOrderOnTable(props.table?.is_terminal ? 'pre_pay' : state.payment_method, state.after_pay_method)
                      :
                        () => handleError([t('components.checkout.selectPaymentType')])}
              >
                {t('order')} {tableOrderSummary().toFixed(2)}<small>₴</small>
              </Button>}
          </Modal.Body>
        </Modal>}

      {/*QRprove modal*/}

      { !!restaurant && state.showInitialModal &&
        <Modal className="fade" show={state.showInitialModal}>
          <Modal.Header style={{justifyContent: 'center'}}>
            <Modal.Title>
              <h3 className='text-black mb-0'>
                {translateRecord(restaurant, 'name')}
              </h3>
            </Modal.Title>
            <Button variant="" className="close" onClick={() => setState({...state, showInitialModal: false})}>
              <span>&times;</span>
            </Button>
          </Modal.Header>
          <Modal.Body>
            <h4 className='text-black text-center'>{t('components.menu.repeatQR')}</h4>
            <QRcodeReader action={state.qrProveFunction} history={props.history}
             checking={[`${window.location.protocol}//${window.location.host}/restaurants/${props.restaurant.slug}/menu?${props.restaurant.table.id}`,
              `${window.location.protocol}//${window.location.host}/r/${props.restaurant.slug}/menu?${props.restaurant.table.id}`]}
            />
            { !state.detectedLocation.lat &&
              <>
                <h4 className='text-center'>або</h4>
                <Button className='btn-outline-primary w-100' onClick={grantGeoLocation}>
                  Надати доступ до геолокації
                </Button>
              </>}
          </Modal.Body>
        </Modal>}

      {state.showGetLocation && <GetLocation onLocationChange={handleLocationChange}/>}
    </div>
  );
};

export default Menu;

